import { render, staticRenderFns } from "./trio-card-action.vue?vue&type=template&id=4d27ef43&"
import script from "./trio-card-action.vue?vue&type=script&lang=js&"
export * from "./trio-card-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports